
var scoreSwiper = null;

function startSwiper() {
    scoreSwiper = new Swiper('.scores-container', {
        // grabCursor: false,
        loop: false,
		swipeHandler: '.swiper-header',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        preloadImages: false,
		initialSlide: typeof initialSlide !== "undefined" ? initialSlide : 0,
        threshold: 30,
        onSlideChangeStart: function() {},
        onSlideChangeEnd: function() {
            var menuItem = $('.scores-container .swiper-slide-active').attr('data-menu-toggle');
            $('.score-button').removeClass('active');
            $('.score-button[data-menu-button=' + menuItem + ']').addClass('active');
        }
    });

    // if (scoreSwiper.slideTo) {
    // 	scoreSwiper.slideTo(0);
	// }
}

$(function() {
    $(window).on('resize', function() {
        if (window.innerWidth < 768) {
            if (scoreSwiper !== null && typeof scoreSwiper.destroy == 'function') {
                scoreSwiper.destroy(true, true);
                scoreSwiper = null;
            }

        } else {
            if (scoreSwiper == null) {
                $('.scores-content').show();
                $('.scores-item .scores-content').removeAttr('style');
                $('.scores-item .scores-button').removeClass('active').removeClass('closed');
                startSwiper();
            }
        }
    }).trigger('resize');


    $('.score-link').on('click', function(e) {
		e.preventDefault();

		if (window.innerWidth < 768) {
			var $rewards = $('#rewards');

			$rewards.slideDown();
			scrollTo($rewards);
		}
	});


    $('.scores-menu-top .score-button').on('click', function (e) {
        e.preventDefault();

        var menuData = $(this).attr('data-menu-button');
        $('.score-button').removeClass('active');
        $(this).addClass('active');

        var slide = $('.swiper-slide[data-menu-toggle=' + menuData + ']');

        if (scoreSwiper !== null) {
        	scoreSwiper.slideTo(slide.index());
		}
    });


    $('.scores-item .score-button').on('click', function(e) {
        e.preventDefault();

        var $scoresItem      = $(this).closest('.scores-item');
        var $otherScoreItems = $('.scores-item').not($scoresItem).not('.dashboard, .rewards');

        $otherScoreItems.find('.scores-content').slideUp();
        $otherScoreItems.find('.score-button').removeClass('active');

        $(this).toggleClass('active');

        if ($(this).hasClass('active')) {
        	$scoresItem.find('.scores-content').slideDown();
		} else {
        	$scoresItem.find('.scores-content').slideUp();
		}
    });


    $('a.score-link').on('click', function(e) {
        // e.preventDefault();

        var menuData = $(this).attr('data-menu-button');
        $('.score-button').removeClass('active');

        var slide = $('.swiper-slide[data-menu-toggle=' + menuData + ']');

        if (scoreSwiper !== null) {
            scoreSwiper.slideTo(slide.index());
        }
    });


    $('.kpi-quarter-warning').on('click', function(e) {
        e.preventDefault();

        $('.kpi-warning').html($(this).data('warning')).slideDown();
    });
});

function showTotalScores(type) {
	// $('.scores-totals').not('.' + type).fadeOut('fast', function() {
	// 	$('.scores-totals.' + type).fadeIn('fast');

		setTimeout(function() {
			var swiper = prizeSwipers[type];

			if (!swiper) {

			}

			swiper.update();
			swiper.slideTo($('.scores-totals.' + type + ' .swiper-slide-active').index(), 0);
		}, 10);
	// });
}

function setCurrentPrize() {
	$('.scores-totals').each(function() {
		var type   = $(this).data('type');
		var swiper = prizeSwipers[type];

		var newScore      = $(this).find('.counter').data('counter-end') || -1;
		var includeScores = [];

		$(this).find('.score-prize').each(function() {
			var score = parseInt($(this).data('score'));

			if (newScore >= score) {
				includeScores.push(score);
			}
		});

		maxIncludeScore = Math.max.apply(Math, includeScores);
		$newSlide = $(this).find('.score-prize[data-score="' + maxIncludeScore + '"]:first');

		if ($newSlide.length > 0) {
			swiper.slideTo($newSlide.index(), 700);
		}
		// Rewards slide
		$('.progress-level').removeClass('active-' + type).filter('[data-score="' + maxIncludeScore + '"]').addClass('active-' + type);
	});
}
